import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="green"> PRESENT MYSELF </span> OFFICIALLY,,
            </h1>
            <p className="home-about-body">
              I fell in love with programming the moment i ventured into tech field👌
              atleast i can say i've learnt something, can't you?? 🤷‍♂️
              <br />
              <br />I'm proeficient in langs like
              <i>
                <b className="green"> python,  java,  Javascript,  html5  and  css3. </b>
              </i>
              <br />
              <br />
              My field of Interest's are &nbsp;
              <i>
                <b className="purple">CyberSecurity,  Web Technologies,  software developing </b> and
                also in areas related to{" "}
                <b className="purple">
                   Blockchain Technologies,
                </b>
              </i>
              <br />
              <br />
              I also play my part as a cybersecurity analyst
              using <b className="purple">Kali Linux</b> OS
              <i>
                <b className="green">
                  {" "}
                  not forgetting some interests in Forensics
                </b>
              </i>
              &nbsp; with tools like 
              <i>
                <b className="purple">Maltego,  guymager, and  wireshark</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="green">reach out </span>to me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/chege-5"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                href="https://x.com/chege_chege2?t=gM_flIHTxxYGQxwNuWflXQ&s=09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/kihara-chege-3b2198321?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/chege.kihara/profilecard/?igsh=MTYyd3ZvcGtzNXJ0Mg=="
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
